import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  PolicyTable,
  SectionCompleteImageContainer,
  DefaultBigTitle,
  DefaultBigSubtitle
} from '../../../components/application/defaultComponents'
import ApplicationPrebuiltFooter from '../../../components/application/PrebuiltBodyFooter'
import flagWithCheckImg from 'src/assets/applicationFormsImgs/flag_with_check.svg'
import { useApplication } from 'src/context/application'

const SectionComplete = () => {
  const { application } = useApplication()

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent width='80%'>
        <DefaultBigTitle>Section Complete! We'll send you quotes for your policies once your application is finished</DefaultBigTitle>
        <br />
        <PolicyTable>
          <tbody>
            <tr>
              <td style={{ padding: 0 }}>
                <SectionCompleteImageContainer>
                  <img src={flagWithCheckImg} alt="Policy Types" />
                </SectionCompleteImageContainer>
              </td>
            </tr>
          </tbody>
        </PolicyTable>
        <br/><br />
        <DefaultBigSubtitle>Next, you can review your application and sign our Warranty, Subscriber's Agreement, and Power of Attorney.</DefaultBigSubtitle>
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute="/quote/select"
        nextRoute="/review/firm"
        updatedApplication={application}
      />
    </ApplicationBodyContainer>
  )
}

export default SectionComplete